import React, { useState, useContext } from 'react'
import MapContext from '../../Map/MapContext'
import DOMPurify from 'dompurify'
import { useGlobalVariablesContext } from '../../../context/GlobalVariablesContext';

import { Vector as VectorLayer } from 'ol/layer'
import VectorSource from 'ol/source/Vector'
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style'
import { Polygon } from 'ol/geom'
import Feature from 'ol/Feature'

import { toLonLat } from 'ol/proj'
import './CatastroData.css'


function CatastroData() {
  const [referencia, setReferencia] = useState('')
  const [detalleCatastro, setDetalleCatastro] = useState('')
  const [error, setError] = useState('')
  const { map } = useContext(MapContext)
  const { config, loading: configLoading } = useGlobalVariablesContext();
  const [returnData, setReturnData] = useState(false)

  /*****************************************************************************
   * FUNCIONES
   ****************************************************************************/
  /**
 * @author Erabasco
 * @param {*} etiqueta (etiqueta a extraer )
 * @param {*} cadena  (cadena a buscar)
 * @param {*} clean  (caracter o caracteres a limpiar)
 * @returns
 */
  function jsonFromlabelXML(etiqueta, cadena, clean = '') {
    const lenghtEtiqueta = etiqueta.length + 1
    let result = ''; let label = ''; let labelClean = ''
    const inicio = cadena.indexOf('<' + etiqueta)
    const fin = cadena.indexOf(etiqueta + '>')

    label = cadena.substring(inicio, fin + lenghtEtiqueta) // la cadena contiene más parametros dentro

    if (fin - inicio === 1) {
      label = cadena.substring(inicio, cadena.lastIndexOf(etiqueta) + lenghtEtiqueta) // no contiene + parametros
    }

    // Limpiamos cadena y extraemos el label en json
    String.prototype.replaceAll = function (search, replacement) {
      return this.replace(new RegExp(search, 'g'), replacement)
    }

    labelClean = label.replaceAll(clean, '')
    result = xmlToJSON.parseString(labelClean)

    return result
  }

  /**
 * @author William Summers
 *
 */

  const xmlToJSON = (function () {
    this.version = '1.3.4'

    const options = { // set up the default options
      mergeCDATA: true, // extract cdata and merge with text
      grokAttr: true, // convert truthy attributes to boolean, etc
      grokText: true, // convert truthy text/attr to boolean, etc
      normalize: true, // collapse multiple spaces to single space
      xmlns: true, // include namespaces as attribute in output
      namespaceKey: '_ns', // tag name for namespace objects
      textKey: '_text', // tag name for text nodes
      valueKey: '_value', // tag name for attribute values

      attrKey: '_attr', // tag for attr groups
      cdataKey: '_cdata', // tag for cdata nodes (ignored if mergeCDATA is true)
      attrsAsObject: false, // if false, key is used as prefix to name, set prefix to '' to merge children and attrs.
      stripAttrPrefix: true, // remove namespace prefixes from attributes
      stripElemPrefix: true, // for elements of same name in diff namespaces, you can enable namespaces and access the nskey property
      // childrenAsArray: true // force children into arrays
      childrenAsArray: false // force children into arrays
    }

    const prefixMatch = new RegExp(/(?!xmlns)^.*:/)
    const trimMatch = new RegExp(/^\s+|\s+$/g)

    this.grokType = function (sValue) {
      if (/^\s*$/.test(sValue)) {
        return null
      }
      if (/^(?:true|false)$/i.test(sValue)) {
        return sValue.toLowerCase() === 'true'
      }
      if (isFinite(sValue)) {
        return parseFloat(sValue)
      }
      return sValue
    }

    this.parseString = function (xmlString, opt) {
      return this.parseXML(this.stringToXML(xmlString), opt)
    }

    this.parseXML = function (oXMLParent, opt) {
      // initialize options
      for (const key in opt) {
        options[key] = opt[key]
      }

      let vResult = {}
      let nLength = 0
      let sCollectedTxt = ''

      // parse namespace information
      if (options.xmlns && oXMLParent.namespaceURI) {
        vResult[options.namespaceKey] = oXMLParent.namespaceURI
      }

      // parse attributes
      // using attributes property instead of hasAttributes method to support older browsers
      if (oXMLParent.attributes && oXMLParent.attributes.length > 0) {
        const vAttribs = {}

        for (nLength; nLength < oXMLParent.attributes.length; nLength++) {
          const oAttrib = oXMLParent.attributes.item(nLength)
          vContent = {}
          let attribName = ''

          if (options.stripAttrPrefix) {
            attribName = oAttrib.name.replace(prefixMatch, '')
          } else {
            attribName = oAttrib.name
          }

          if (options.grokAttr) {
            vContent[options.valueKey] = this.grokType(oAttrib.value.replace(trimMatch, ''))
          } else {
            vContent[options.valueKey] = oAttrib.value.replace(trimMatch, '')
          }

          if (options.xmlns && oAttrib.namespaceURI) {
            vContent[options.namespaceKey] = oAttrib.namespaceURI
          }

          if (options.attrsAsObject) { // attributes with same local name must enable prefixes
            vAttribs[attribName] = vContent
          } else {
            vResult[options.attrKey + attribName] = vContent
          }
        }

        if (options.attrsAsObject) {
          vResult[options.attrKey] = vAttribs
        } else { }
      }

      // iterate over the children
      if (oXMLParent.hasChildNodes()) {
        for (var oNode, sProp, vContent, nItem = 0; nItem < oXMLParent.childNodes.length; nItem++) {
          oNode = oXMLParent.childNodes.item(nItem)

          if (oNode.nodeType === 4) {
            if (options.mergeCDATA) {
              sCollectedTxt += oNode.nodeValue
            } else {
              if (vResult.hasOwnProperty(options.cdataKey)) {
                if (vResult[options.cdataKey].constructor !== Array) {
                  vResult[options.cdataKey] = [vResult[options.cdataKey]]
                }
                vResult[options.cdataKey].push(oNode.nodeValue)
              } else {
                if (options.childrenAsArray) {
                  vResult[options.cdataKey] = []
                  vResult[options.cdataKey].push(oNode.nodeValue)
                } else {
                  vResult[options.cdataKey] = oNode.nodeValue
                }
              }
            }
          } /* nodeType is "CDATASection" (4) */
          else if (oNode.nodeType === 3) {
            sCollectedTxt += oNode.nodeValue
          } /* nodeType is "Text" (3) */
          else if (oNode.nodeType === 1) { /* nodeType is "Element" (1) */
            if (nLength === 0) {
              vResult = {}
            }

            // using nodeName to support browser (IE) implementation with no 'localName' property
            if (options.stripElemPrefix) {
              sProp = oNode.nodeName.replace(prefixMatch, '')
            } else {
              sProp = oNode.nodeName
            }

            vContent = xmlToJSON.parseXML(oNode)

            if (vResult.hasOwnProperty(sProp)) {
              if (vResult[sProp].constructor !== Array) {
                vResult[sProp] = [vResult[sProp]]
              }
              vResult[sProp].push(vContent)
            } else {
              if (options.childrenAsArray) {
                vResult[sProp] = []
                vResult[sProp].push(vContent)
              } else {
                vResult[sProp] = vContent
              }
              nLength++
            }
          }
        }
      } else if (!sCollectedTxt) { // no children and no text, return null
        if (options.childrenAsArray) {
          vResult[options.textKey] = []
          vResult[options.textKey].push(null)
        } else {
          vResult[options.textKey] = null
        }
      }

      if (sCollectedTxt) {
        if (options.grokText) {
          const value = this.grokType(sCollectedTxt.replace(trimMatch, ''))
          if (value !== null && value !== undefined) {
            vResult[options.textKey] = value
          }
        } else if (options.normalize) {
          vResult[options.textKey] = sCollectedTxt.replace(trimMatch, '').replace(/\s+/g, ' ')
        } else {
          vResult[options.textKey] = sCollectedTxt.replace(trimMatch, '')
        }
      }

      return vResult
    }

    // Convert xmlDocument to a string
    // Returns null on failure
    this.xmlToString = function (xmlDoc) {
      try {
        const xmlString = xmlDoc.xml ? xmlDoc.xml : (new XMLSerializer()).serializeToString(xmlDoc)
        return xmlString
      } catch (err) {
        return null
      }
    }

    // Convert a string to XML Node Structure
    // Returns null on failure
    this.stringToXML = function (xmlString) {
      try {
        let xmlDoc = null

        if (window.DOMParser) {
          const parser = new DOMParser()
          xmlDoc = parser.parseFromString(xmlString, 'text/xml')

          return xmlDoc
        } else {
          xmlDoc = new ActiveXObject('Microsoft.XMLDOM')
          xmlDoc.async = false
          xmlDoc.loadXML(xmlString)

          return xmlDoc
        }
      } catch (e) {
        return null
      }
    }

    return this
  }.call({}))

  /**
 * @author Erabasco
 * @param {*} etiqueta
 * @param {*} cadena
 * @param {*} clean (caracteres a limpiar)
 * @param {*} labelCierre (si es diferente del normal)
 * @returns
 */
  function labelfromXML(etiqueta, cadena, clean = '', labelCierre = '') {
    let fin; const lenghtEtiqueta = etiqueta.length + 1
    let label = ''
    const inicio = cadena.indexOf('<' + etiqueta)
    fin = cadena.indexOf(etiqueta + '>')
    if (labelCierre !== '') {
      fin = cadena.indexOf(labelCierre)
    }

    label = cadena.substring(inicio, fin + lenghtEtiqueta) // la cadena contiene más parametros dentro

    if (fin - inicio === 1) {
      label = cadena.substring(inicio, cadena.lastIndexOf(etiqueta) + lenghtEtiqueta) // no contiene + parametros
    }

    // Limpiamos cadena y extraemos el label en json
    String.prototype.replaceAll = function (search, replacement) {
      return this.replace(new RegExp(search, 'g'), replacement)
    }

    label = label.replaceAll(clean, '')

    return label
  }

  function activarSpinner() {
    document.getElementById('preloaderCatastro').style.display = 'block'
  }

  function desactivarSpinner() {
    document.getElementById('preloaderCatastro').style.display = 'none' // ocultamos el spinner
  }

  function transformToLonLat(coord3857) {
    const aPos = coord3857.split(' ')
    const coordenadas = [Number.parseFloat(aPos[0]), Number.parseFloat(aPos[1])]
    return coordenadas
  }

  function limpiarVectorLayerDatos() {
    // Comprobamos si hay alguna capa anterior VectorLayer
    // https://gis.stackexchange.com/questions/240372/how-do-i-get-all-the-layer-vectors-added-to-a-map-in-openlayers-3
    map.getLayers().forEach(function (layer) {
      if (layer instanceof VectorLayer && layer.get('name') === 'VectorParcela') {
        map.removeLayer(layer)
      }
    })
  }

  function aniadeCapaVectorDelimitacionParcela(coordenadas) {
    const sourcePoligon = new VectorSource()

    const vectorLayerPoligon = new VectorLayer({
      name: 'VectorParcela',
      source: sourcePoligon,
      style: new Style({

        fill: new Fill({
          color: 'rgba(50, 98, 163, 0.2)'
        }),
        stroke: new Stroke({
          color: 'rgba(50, 98, 163, 0.9)', // blue
          width: 10
        }),
        image: new CircleStyle({
          radius: 10,
          fill: new Fill({
            color: 'rgba(50, 98, 163, 0.2)'
          })
        })
      })
    })

    // El polígono aquí debe ser [matriz de coordenadas]
    const plygon = new Polygon([coordenadas])

    const feature = new Feature({
      geometry: plygon
    })
    vectorLayerPoligon.getSource().clear()
    sourcePoligon.addFeature(feature)
    map.addLayer(vectorLayerPoligon)

    const view = map.getView()

    view.fit(vectorLayerPoligon.getSource().getExtent(), {
      padding: [80, 50, 110, 50], // Opcional: Añade un espacio alrededor de las características
      duration: 1000 // Opcional: Duración de la animación de ajuste
    })
  }

  function dibujaParcela(coordenadas) {
    // transformamos las coordenadas desde una matriz de puntos separada por espacios
    // EPSG::3857 a array de puntos lat,lon
    const aCoordenadas = coordenadas.split(' ')

    const coordenadasLonLatPoligono = []
    for (let i = 0; i < aCoordenadas.length; i = i + 2) {
      coordenadasLonLatPoligono.push([Number.parseFloat(aCoordenadas[i]), Number.parseFloat(aCoordenadas[i + 1])])
    }

    limpiarVectorLayerDatos()
    aniadeCapaVectorDelimitacionParcela(coordenadasLonLatPoligono)
  }


  function linkDatosRC() {
    const rc = referencia
    const rc1 = rc.substring(0, 7)
    const rc2 = rc.substring(7, 14)

    const urlDatosDetallados = 'https://www1.sedecatastro.gob.es/CYCBienInmueble/OVCListaBienes.aspx?' +
      'RC1=' + rc1 +
      '&RC2=' + rc2 +
      '&RCCompleta=' + rc +
      '&from=OVCBusqueda&tipoCarto=nuevo&ZV=NO&ZR=NO'
    const linkHtml = `<strong>Enlace a Sede Catastro </strong><br><a class="font-weight-bold" target="_blank" rel="noopener noreferrer" href="${urlDatosDetallados}">${rc} </a>`
    // setDetalleCatastro((prev) => [...prev, linkHtml])
    setDetalleCatastro((prev) => prev + linkHtml)
  }

  function loadSuperficieParcela(areaValue) {
    const superficie = `<br><br> <strong>Superficie gráfica parcela</strong><br> ${new Intl.NumberFormat().format(areaValue)} m<sup>2</sup> `
    // setDetalleCatastro((prev) => [...prev, superficie])
    setDetalleCatastro((prev) => prev + superficie)
  }

  function loadLonLat(evt, pointPos) {
    let coordinates
    if (evt === undefined) {
      const aPoint = pointPos.split(' ')
      const aPointNumber = [Number(aPoint[0]), Number(aPoint[1])]
      coordinates = aPointNumber
    } else {
      coordinates = evt.coordinate
    }
    const cLonLat = toLonLat(coordinates, 'EPSG:3857')
    const coordenadas = '<br><br><strong>Coordenadas </strong> <br>' + cLonLat[0].toFixed(5) + ', ' + cLonLat[1].toFixed(5) + '<br>'
    setDetalleCatastro((prev) => prev + coordenadas)
    // setDetalleCatastro((prev) => [...prev, coordenadas])
  }

  function displayResultOK(data, evt) {
    // limpiarResult()

    // coordenadas delimitacion parcela
    try {
      const posList = jsonFromlabelXML('gml:posList', data, 'gml:').posList._text
      const areaValue = jsonFromlabelXML('cp:areaValue', data, 'cp:').areaValue._text
      const pointPos = jsonFromlabelXML('gml:Point', data, 'gml:').Point.pos._text

      linkDatosRC()

      // loadSuperficieParcela(areaValue)
      // loadLonLat(evt, pointPos)

      // direccionWithImg()
      // imagenParcela()
      dibujaParcela(posList)
      // zoomTo(transformToLonLat(posList), 15)
    } catch (error) {
      console.log('No se ha encontrado la parcela con esa referencia')
    }
  }

  function getDataCatastro() {
    // Validar que la configuración esté disponible
    if (!config || !config.PROXY_CATASTRO || !config.PROXY_CATASTRO.CADASTRE_PARCEL_BY_REF) {
      setError('La configuración del catastro no está disponible. Por favor, recarga la página.')
      console.error('PROXY_CATASTRO no está configurado:', config)
      return
    }

    const urlPC = config.PROXY_CATASTRO.CADASTRE_PARCEL_BY_REF + referencia

    activarSpinner()

    fetch(urlPC, {
      method: 'GET'
    })
      .then(function (response) {
        desactivarSpinner()
        return response.text()
      })
      .then(data => {
        if (data === 'error') {
          // displayResultError()
          console.log('Hay algún error en la petición')
        } else {
          setReturnData(true);
          displayResultOK(data)
          // console.log(data)
          return null
        }
      })
  }

  /*****************************************************************************
   * FIN FUNCIONES
   ****************************************************************************/

  /** **************** Eventos **************************/

  const handleInputChange = (event) => {
    const inputValue = event.target.value
    setReferencia(inputValue)
    setError('') // Limpiamos el mensaje de error al cambiar el valor del input
  }

  const handleInputBlur = () => {
    // Validación: Longitud exacta de 14 caracteres alfanuméricos y sin espacios en blanco
    const isValid = /^[a-zA-Z0-9]{14}$/.test(referencia) && !/\s/.test(referencia)

    if (!isValid) {
      setError('La referencia debe tener 14 caracteres alfanuméricos y no debe contener espacios en blanco')
    }
  }
  // Al pulsar el botón buscar, también validamos que la referencia tenga 14 caracteres alfanuméricos y sin espacios
  const handleSearchReferencia = () => {
    // Limpiar errores previos
    setError('')

    // Validar que la configuración esté cargada
    if (configLoading) {
      setError('Cargando configuración, por favor espere...')
      return
    }

    if (!config || !config.PROXY_CATASTRO) {
      setError('La configuración del catastro no está disponible. Por favor, recarga la página.')
      console.error('PROXY_CATASTRO no está disponible en la configuración:', config)
      return
    }

    // Validación: Longitud exacta de 14 caracteres alfanuméricos y sin espacios en blanco
    const isValid = /^[a-zA-Z0-9]{14}$/.test(referencia) && !/\s/.test(referencia);

    if (!isValid) {
      setError('La referencia debe tener exactamente 14 caracteres alfanuméricos y no debe contener espacios en blanco');
      return;
    }

    // Si llegamos aquí, todo está bien, ejecutamos la búsqueda
    setDetalleCatastro('')
    getDataCatastro()
  }

  const handleClean = () => {
    setReturnData(false)
    setDetalleCatastro('')
    limpiarVectorLayerDatos()
    setReferencia('')
    setError('')
  }

  /** ***************** FIN Eventos **************************/

  return (
    <>
      <div className='contentSearchCatastro'>
        <label className='text-bold' htmlFor='referencia'>
          <strong>Referencia Catastral - Parcelas</strong>
        </label>

        <input
          type='text'
          placeholder='Longitud 14 dígitos'
          name='referencia'
          id='referencia'
          maxLength='14'
          className='form-control mr-3'
          value={referencia}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />

        {error && <p style={{ color: 'red' }}>{error}</p>}

        <button 
          id='bBuscarReferenciaCatastral' 
          className='btn btn-primary me-1' 
          onClick={handleSearchReferencia}
          disabled={configLoading}
        >
          Buscar
        </button>
        <button id='bLimpiarReferenciaCatastral' className='btn btn-secondary' onClick={handleClean}>
          Limpiar
        </button>
      </div>

      {/* <!-- Preloader --> */}
      <div className='container pt-4 pr-5' id='preloaderCatastro' style={{ display: 'none', width: '100%', textAlign: 'center' }}>
        <br />
        <div className='preloader' style={{ display: 'inline-block' }} />
        <p>
          <strong>Conectando con catastro ...</strong>
        </p>
      </div>

      {/* <!-- Result Catastro--> */}
      {returnData && (
        <div id='resultContainer'>
          <div id='resultCatastroHead' />
          <div
            id='resultCatastroBody'
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(detalleCatastro, {
                ADD_ATTR: ['target', 'rel']
              })
            }}
            
          />
        </div>
      )}

    </>
  )
}

export default CatastroData
